// extracted by mini-css-extract-plugin
export var quantityInput = "_i8-0";